import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Text } from 'shared/Typhography';

import { getThemeById, GameplayThemeData } from '../../../../services/api/themesApi';

import ThemeForm from './components/ThemeForm/ThemeForm';

export const ManageThemeScreen: React.FC = () => {
  const { id: themeId } = useParams<{ id?: string }>();
  const isCreate = !themeId;

  const [existingTheme, setExistingTheme] = useState<GameplayThemeData | null>(null);
  const [isLoading, setIsLoading] = useState(!isCreate);

  useEffect(() => {
    if (!themeId) return;
    setIsLoading(true);
    getThemeById(themeId)
      .then((theme) => setExistingTheme(theme))
      .catch(console.error)
      .finally(() => setIsLoading(false));
  }, [themeId]);

  return (
    <Box margin="120px auto 40px auto" style={{ maxWidth: 1100, padding: '0 24px' }}>
      <Text size={2} weight="bold">
        {isCreate ? 'Create Theme' : 'Edit Theme'}
      </Text>
      {isLoading ? (
        <div style={{ marginTop: 48, textAlign: 'center', color: '#888' }}>Loading theme…</div>
      ) : (
        <ThemeForm existingTheme={existingTheme} themeId={themeId} />
      )}
    </Box>
  );
};
